import { InfoActionSheetProps } from '@ocx-app/components/modals/InfoActionSheet/info-action-sheet.types';

export const isVariantWithStatusIcon = (variant: InfoActionSheetProps['variant']) => {
  return variant ? ['congrats', 'not-verified', 'verified'].includes(variant) : false;
};
